import { fetchWithTimeout, parseErrorResponse } from './base.ts';

export interface OnboardingState {
  wizardCompleted?: boolean;
  wizardSkipped?: boolean;
  wizardCompletedAt?: string | null;
  checklist?: {
    projectCreated?: boolean;
    probandSet?: boolean;
    fivePersonsAdded?: boolean;
    sourceLinked?: boolean;
    gedcomImported?: boolean;
    fanChartViewed?: boolean;
  };
  tours?: Record<string, { completed: boolean; completedAt: string | null }>;
  checklistDismissed?: boolean;
  checklistExpanded?: boolean;
}

export const onboardingApi = {
  async getState(): Promise<OnboardingState> {
    const res = await fetchWithTimeout('/api/onboarding');
    if (!res.ok) return {};
    return res.json();
  },

  async updateState(partial: Partial<OnboardingState>): Promise<OnboardingState> {
    const res = await fetchWithTimeout('/api/onboarding', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(partial),
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },
};
